import { render, staticRenderFns } from "./v-code-display.vue?vue&type=template&id=78defbfc&scoped=true&"
import script from "./v-code-display.vue?vue&type=script&lang=js&"
export * from "./v-code-display.vue?vue&type=script&lang=js&"
import style0 from "./v-code-display.vue?vue&type=style&index=0&id=78defbfc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78defbfc",
  null
  
)

export default component.exports